import React from 'react';
import {FooterBottom, FooterTop} from '.';
import './footer.css';

export function Footer({siteData, setShowSignUpModal}) {
  return (
    <footer>
      <FooterTop milanStores={siteData.milanStores} currentMetro={siteData.currentMetro} />
      <FooterBottom currentMetro={siteData.currentMetro} setShowSignUpModal={setShowSignUpModal} />
    </footer>
  );
}
export default Footer;
